/* Selector de fotografía SS09
   - Overlay: se abre al ingresar la clave o al entrar a la colección (una vez por sesión), desde el carrito, o con ?foto=1.
   - La elección vive en el carrito como atributo ("SS09": "Foto 03") + "_sofs_foto" (handle, para stock).
     Si todavía no hay carrito con piezas SS09, se guarda en el navegador y se pasa al agregar la primera.
   - Disponibilidad se revisa en vivo al abrir el overlay, al cargar el carrito y al pulsar "Ir a pagar". */
(function () {
  if (window.__sofsPhotoPicker) return;
  window.__sofsPhotoPicker = true;

  var cfgEl = document.querySelector('[data-sofs-photo-config]');
  if (!cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = CFG.t, ATTR = CFG.attr || 'SS09', HKEY = '_sofs_foto';
  var LS = 'sofs_photo_choice', SS = 'sofs_photo_shown';
  var PRODUCTS = (CFG.products || []).map(String);

  var photos = readData(document);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function readData(doc) {
    var el = doc.querySelector('[data-sofs-photo-data]');
    try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
  }
  function refreshData() {
    return fetch(root + '?sections=sofs-photo-data', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var d = new DOMParser().parseFromString(j['sofs-photo-data'] || '', 'text/html');
        var fresh = readData(d);
        if (fresh.length) photos = fresh;
        return photos;
      })
      .catch(function () { return photos; });
  }
  function byHandle(h) { for (var i = 0; i < photos.length; i++) if (photos[i].h === h) return photos[i]; return null; }
  function lsGet() { try { return JSON.parse(localStorage.getItem(LS) || 'null'); } catch (e) { return null; } }
  function lsSet(v) { try { v ? localStorage.setItem(LS, JSON.stringify(v)) : localStorage.removeItem(LS); } catch (e) {} }
  function ssGet() { try { return sessionStorage.getItem(SS); } catch (e) { return null; } }
  function ssSet() { try { sessionStorage.setItem(SS, '1'); } catch (e) {} }

  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var ICON_CK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ───────── Carrito ───────── */
  function getCart() { return fetch(root + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function cartHasSS09(cart) {
    if (!PRODUCTS.length) return false;
    return (cart.items || []).some(function (it) { return PRODUCTS.indexOf(String(it.product_id)) > -1; });
  }
  function setCartChoice(p) {
    var a = {}; a[ATTR] = p ? p.n : ''; a[HKEY] = p ? p.h : '';
    return fetch(root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: a })
    }).then(function (r) { return r.json(); });
  }
  function currentChoice(cart) {
    var h = cart && cart.attributes && cart.attributes[HKEY];
    if (h) return h;
    var l = lsGet(); return l && l.h;
  }
  // Pone el carrito en orden: pasa la elección del navegador, o la quita si ya no hay piezas SS09.
  function syncCart(cart) {
    var has = cartHasSS09(cart), attrs = cart.attributes || {};
    if (has && !attrs[HKEY]) {
      var l = lsGet(); var p = l && byHandle(l.h);
      if (p) return setCartChoice(p);
    }
    if (!has && attrs[HKEY]) return setCartChoice(null);
    return Promise.resolve(cart);
  }

  function renderCartBlocks() {
    var els = document.querySelectorAll('sofs-photo-cart');
    if (!els.length) return Promise.resolve();
    return Promise.all([getCart(), refreshData()]).then(function (res) {
      return syncCart(res[0]);
    }).then(function (cart) {
      var has = cartHasSS09(cart);
      var p = byHandle(currentChoice(cart));
      els.forEach(function (el) { el.paint(has, p); });
    }).catch(function () {});
  }

  if (!customElements.get('sofs-photo-cart')) {
    customElements.define('sofs-photo-cart', class extends HTMLElement {
      connectedCallback() {
        this.hidden = true;
        if (!this._wired) {
          this._wired = true;
          this.addEventListener('click', function (e) {
            if (e.target.closest('[data-sofs-pc-open]')) { e.preventDefault(); openPicker({ fromCart: true }); }
          });
        }
        clearTimeout(window.__sofsPcT);
        window.__sofsPcT = setTimeout(renderCartBlocks, 30);
      }
      paint(has, p) {
        if (!has) { this.hidden = true; this.innerHTML = ''; return; }
        var gone = p && !p.ok;
        this.hidden = false;
        this.innerHTML =
          '<div class="sofs-pc' + (p ? ' is-chosen' : '') + (gone ? ' is-gone' : '') + '">' +
            '<p class="sofs-pc__head">' + esc(T.cartHeading) + '</p>' +
            '<div class="sofs-pc__row">' +
              '<div class="sofs-pc__thumb">' + (p && p.s ? '<img src="' + esc(p.s) + '" alt="">' : '') + '</div>' +
              '<div class="sofs-pc__txt">' +
                '<p class="sofs-pc__name">' + esc(p ? p.n : T.cartEmpty) + '</p>' +
                (gone ? '<p class="sofs-pc__sub">' + esc(T.cartGone) + '</p>' : (p ? '<p class="sofs-pc__sub">' + esc(T.cartSub) + '</p>' : '')) +
              '</div>' +
              '<button type="button" class="sofs-pc__btn" data-sofs-pc-open>' + esc(p && !gone ? T.cartChange : T.choose) + '</button>' +
            '</div>' +
          '</div>';
      }
    });
  }
  ['theme:cart:added', 'theme:cart:update', 'theme:cart:loaded', 'theme:cart:open'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(renderCartBlocks, 400); });
  });

  // "Ir a pagar": si la foto elegida se agotó, se frena y el bloque lo dice.
  var checkoutOk = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (!btn || checkoutOk) return;
    e.preventDefault(); e.stopImmediatePropagation();
    Promise.all([getCart(), refreshData()]).then(function (res) {
      var cart = res[0], p = byHandle(currentChoice(cart));
      if (cartHasSS09(cart) && p && !p.ok) {
        return renderCartBlocks().then(function () {
          var b = document.querySelector('sofs-photo-cart:not([hidden])');
          if (b) b.scrollIntoView({ block: 'nearest' });
        });
      }
      checkoutOk = true; btn.click(); setTimeout(function () { checkoutOk = false; }, 1500);
    }).catch(function () { checkoutOk = true; btn.click(); setTimeout(function () { checkoutOk = false; }, 1500); });
  }, true);

  /* ───────── Overlay ───────── */
  var ov = null, state = 'closed', sel = null, timer = null, fly = null, flyName = null;

  function openPicker(opts) {
    if (state !== 'closed') return;
    state = 'loading';
    refreshData().then(function () {
      if (!photos.length) { state = 'closed'; return; }
      // siempre abre sin ninguna marcada: el efecto sobre las demás aparece solo cuando la persona toca una
      sel = null;
      build();
      state = 'pick';
    });
  }

  function build() {
    ov = document.createElement('div');
    ov.className = 'sofs-pp';
    ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', T.title);
    var tiles = photos.map(function (p, i) {
      return '<button type="button" class="sofs-pp__tile' + (p.ok ? '' : ' is-off') + (p.h === sel ? ' is-sel' : '') + '" style="--i:' + i + '" data-h="' + esc(p.h) + '"' + (p.ok ? '' : ' aria-disabled="true"') + '>' +
        '<span class="sofs-pp__frame">' + (p.s ? '<img src="' + esc(p.s) + '" alt="' + esc(p.n) + '" loading="eager">' : '') +
          (p.ok ? '<span class="sofs-pp__ck">' + ICON_CK + '</span>' : '<span class="sofs-pp__tag">' + esc(T.soldout) + '</span>') +
        '</span>' +
        '<span class="sofs-pp__name">' + esc(p.n) + '</span>' +
      '</button>';
    }).join('');
    ov.innerHTML =
      '<button type="button" class="sofs-pp__x sofs-pp__fade" aria-label="' + esc(T.close) + '">' + ICON_X + '</button>' +
      '<div class="sofs-pp__inner">' +
        '<p class="sofs-pp__title sofs-pp__fade">' + esc(T.title) + (T.title2 ? '<span class="sofs-pp__t2">' + esc(T.title2) + '</span>' : '') + '</p>' +
        (T.subtitle ? '<p class="sofs-pp__sub sofs-pp__fade">' + esc(T.subtitle) + '</p>' : '') +
        '<div class="sofs-pp__grid">' + tiles + '</div>' +
        '<p class="sofs-pp__err sofs-pp__fade" aria-live="polite"></p>' +
        '<button type="button" class="sofs-pp__btn sofs-pp__fade">' + esc(T.choose) + '</button>' +
      '</div>';
    document.body.appendChild(ov);
    document.documentElement.classList.add('sofs-pp-lock');
    if (sel) ov.classList.add('has-sel');
    void ov.offsetWidth;
    var o = ov;
    setTimeout(function () { o.classList.add('is-open'); }, 20);
    // terminada la entrada escalonada, los cambios (hover/elegir) responden sin demora
    setTimeout(function () { o.classList.add('is-ready'); }, 350 + photos.length * 140 + 1100);

    ov.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
  }

  function onKey(e) { if (e.key === 'Escape' && state === 'pick') close(); }

  function onClick(e) {
    if (state === 'anim') { finish(); return; }
    if (state !== 'pick') return;
    if (e.target.closest('.sofs-pp__x')) { close(); return; }
    if (e.target.closest('.sofs-pp__btn')) { choose(); return; }
    var t = e.target.closest('.sofs-pp__tile');
    if (t && !t.classList.contains('is-off')) {
      sel = t.getAttribute('data-h');
      ov.querySelectorAll('.sofs-pp__tile').forEach(function (x) { x.classList.toggle('is-sel', x === t); });
      ov.classList.add('has-sel');
      ov.querySelector('.sofs-pp__err').textContent = '';
    }
  }

  function choose() {
    var err = ov.querySelector('.sofs-pp__err');
    if (!sel) { err.textContent = T.error; return; }
    var p = byHandle(sel);
    if (!p || !p.ok) { err.textContent = T.error; return; }
    state = 'anim';
    save(p);

    var tile = ov.querySelector('.sofs-pp__tile[data-h="' + CSS.escape(sel) + '"] .sofs-pp__frame');
    var r = tile.getBoundingClientRect();
    fly = document.createElement('div');
    fly.className = 'sofs-pp__fly';
    fly.style.cssText = 'left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px';
    fly.innerHTML = '<img src="' + esc(p.l || p.s) + '" alt="">';
    // la versión grande arranca con la chica ya cargada para que no parpadee
    var big = fly.querySelector('img'); big.src = p.s; if (p.l) { var pre = new Image(); pre.onload = function () { big.src = p.l; }; pre.src = p.l; }
    ov.appendChild(fly);
    tile.style.visibility = 'hidden';
    flyName = document.createElement('p');
    flyName.className = 'sofs-pp__flyname';
    flyName.textContent = p.n;
    ov.appendChild(flyName);
    ov.classList.add('is-anim');

    void fly.offsetWidth; // fija la posición inicial antes de mover
    var f = fly, fn = flyName;
    setTimeout(function () {
      var vw = window.innerWidth, vh = window.innerHeight;
      var w = Math.min(vw - 32, 1000, (vh - 140) * (2481 / 1596));
      var h = w * 1596 / 2481;
      var top = (vh - h) / 2 + 18, left = (vw - w) / 2;
      f.style.left = left + 'px'; f.style.top = top + 'px'; f.style.width = w + 'px'; f.style.height = h + 'px';
      fn.style.top = (top - 44) + 'px';
      fn.classList.add('is-in');
      f.classList.add('is-in');
    }, 30);
    timer = setTimeout(finish, 3400);
  }

  function finish() {
    if (state !== 'anim') return;
    clearTimeout(timer);
    close();
  }

  function close() {
    if (!ov) return;
    state = 'closing';
    ssSet();
    document.removeEventListener('keydown', onKey);
    var node = ov;
    // se muestra siempre (decisión de marca), aunque el sistema pida menos animación
    var dust = fly ? disintegrate(fly) : null;
    if (dust) {
      // la foto se deshace en polvo; el nombre se va y el fondo se desvanece mientras vuela
      if (flyName) { flyName.style.transition = 'opacity .35s ease'; flyName.style.opacity = '0'; }
      setTimeout(function () { node.classList.add('is-closing'); }, 650);
    } else {
      node.classList.add('is-closing');
    }
    setTimeout(function () {
      node.remove();
      document.documentElement.classList.remove('sofs-pp-lock');
      ov = null; fly = null; flyName = null; state = 'closed';
    }, dust ? 1900 : 1300);
    renderCartBlocks();
  }

  /* Desintegración: corta la foto en miles de cuadritos (canvas) y los sopla de izquierda a derecha.
     Usa drawImage directo desde la imagen ya cargada: no lee píxeles, así que no depende de CORS. */
  function disintegrate(el) {
    var img = el.querySelector('img');
    if (!img || !img.complete || !img.naturalWidth) return false;
    var r = el.getBoundingClientRect();
    var W = window.innerWidth, H = window.innerHeight;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var cv = document.createElement('canvas');
    cv.className = 'sofs-pp__dust';
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    cv.style.cssText = 'position:fixed;inset:0;width:' + W + 'px;height:' + H + 'px;z-index:100070;pointer-events:none';
    var ctx = cv.getContext('2d');
    if (!ctx) return false;
    ctx.scale(dpr, dpr);

    // mapear la foto como se ve en pantalla (object-fit:cover + el acercamiento lento)
    var sc = 1;
    try { sc = new DOMMatrix(getComputedStyle(img).transform).a || 1; } catch (e) {}
    var nw = img.naturalWidth, nh = img.naturalHeight;
    var s0 = Math.max(r.width / nw, r.height / nh) * sc;
    var ox = r.left + r.width / 2 - nw * s0 / 2, oy = r.top + r.height / 2 - nh * s0 / 2;

    // tamaño del pedacito: ~5.000-6.000 piezas en computador, ~3.000 en celular
    var P = Math.max(5, Math.round(Math.sqrt(r.width * r.height / 5500)));
    var parts = [];
    for (var y = r.top; y < r.bottom; y += P) {
      for (var x = r.left; x < r.right; x += P) {
        var w = Math.min(P, r.right - x), h = Math.min(P, r.bottom - y);
        var prog = (x - r.left) / r.width;
        parts.push({
          x: x, y: y, w: w, h: h,
          sx: (x - ox) / s0, sy: (y - oy) / s0, sw: w / s0, sh: h / s0,
          d: prog * 520 + Math.random() * 260,          // barrido de izquierda a derecha
          l: 650 + Math.random() * 500,                 // cuánto vive cada pedacito
          vx: 60 + Math.random() * 180,                 // viento hacia la derecha
          vy: -(30 + Math.random() * 140),              // y hacia arriba
          sp: (Math.random() - .5) * 60                 // dispersión
        });
      }
    }
    document.body.appendChild(cv);
    el.style.visibility = 'hidden';

    var t0 = performance.now(), END = 520 + 260 + 1150;
    (function frame(now) {
      var t = now - t0;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i], k = (t - p.d) / p.l;
        if (k >= 1) continue;
        if (k <= 0) { ctx.globalAlpha = 1; ctx.drawImage(img, p.sx, p.sy, p.sw, p.sh, p.x, p.y, p.w, p.h); continue; }
        var e = k * k;                                   // arranca lento y se acelera
        var s = 1 - k * .6;
        ctx.globalAlpha = 1 - k;
        ctx.drawImage(img, p.sx, p.sy, p.sw, p.sh, p.x + p.vx * e + p.sp * k, p.y + p.vy * e, p.w * s, p.h * s);
      }
      if (t < END) requestAnimationFrame(frame); else cv.remove();
    })(t0);
    return true;
  }

  function save(p) {
    lsSet({ h: p.h, n: p.n });
    getCart().then(function (cart) {
      if (cartHasSS09(cart)) return setCartChoice(p);
    }).then(function () {
      renderCartBlocks();
      document.dispatchEvent(new CustomEvent('sofs:photo-chosen', { detail: { handle: p.h, name: p.n } }));
    }).catch(function () {});
  }

  /* ───────── Disparadores ───────── */
  function maybeAfterUnlock(detail) {
    if (detail && detail.fresh && !ssGet()) openPicker({});
  }
  document.addEventListener('sofs:access-unlocked', function (e) { maybeAfterUnlock(e.detail); });
  if (window.sofsAccessUnlocked) maybeAfterUnlock(window.sofsAccessUnlocked);
  if (/[?&]foto=1\b/.test(location.search)) openPicker({});
  /* Al entrar a la colección de la temporada: una vez por sesión, después de la pantalla de carga */
  if (CFG.autoOpen && !ssGet()) {
    var autoGo = function () { setTimeout(function () { if (!ssGet()) openPicker({}); }, 700); };
    if (document.readyState === 'complete') autoGo(); else window.addEventListener('load', autoGo);
  }

  window.sofsPhotoPicker = { open: function () { openPicker({}); } };
})();
